import React from 'react';
import reqwest from 'reqwest';
import ReactTable from 'react-table';

import settings from '../../../../../settings';

import Loader from '../../../../components/Loader';
import Button from '../../../../components/Button';
import RightSide from '../../../../components/FormArea/RightSide';
import ContentBox from '../../../../components/FormArea/ContentBox';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';

class EMailMacroOverview extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      eMailMacroList: [],
      loading: true,
    };

    reqwest({
      method: 'get',
      url: settings.systemmanagement.emailmacro.getList,
      contentType: 'json',
      data: {
        Token: localStorage.getItem('token'),
      },
    }).then(emailmacroListResponse => {
      const eMailMacroList = JSON.parse(emailmacroListResponse).filter(emailclient => {
        return emailclient?.Params?.Guid !== '';
      });

      this.setState({
        eMailMacroList,
        loading: false,
      });
    });
  }

  render() {
    if (this.state.loading) {
      return <Loader />;
    }

    return (
      <>
        <div className='FormArea-Form-Left'>
          <ContentBox title='E-Mail Makros'>
            <ReactTable
              getTrProps={(_, { original }) => ({
                onClick: () => this.props.history.replace(`${this.props.match.url}/${original.Params.Guid}`),
              })}
              data={this.state.eMailMacroList}
              pageSize={this.state.eMailMacroList.length}
              noDataText='Es liegen keine Makros vor.'
              columns={[
                {
                  Header: 'Makro',
                  accessor: 'Params.Title',
                },
              ]}
            />
          </ContentBox>
        </div>
        <RightSide>
          <Button big icon={faPlus} to={`${this.props.match.url}/new`} replace>
            Neues EMail Macro
          </Button>
        </RightSide>
      </>
    );
  }
}

export default EMailMacroOverview;
